export const apiserver = () => {
	if (location.hostname === 'localhost' || location.hostname === '192.168.10.48') {
		return 'https://dev.stella-erp.co.kr';
	} else if (location.hostname === 'dev.stella-erp.co.kr') {
		return 'https://dev.stella-erp.co.kr';
	} else if (location.hostname === 'stg.stella-erp.co.kr') {
		return 'https://stg.stella-erp.co.kr';
	} else {
		return 'https://www.stella-erp.co.kr';
	}
};

const api_version = 'v1';
const api_prefix = `/api/${api_version}/`;
const prefix_mgmtFaq = 'mgmt/faq/';
const prefix_mgmtAnncmt = 'mgmt/anncmt/';
const prefix_mgmtApplyAsk = 'mgmt/apply-ask/';
const prefix_mgmtExpertAsk = 'mgmt/expert-ask/';
const prefix_mgmtEvent = 'mgmt/evnt/';
const prefix_mgmtHomeBnnr = 'mgmt/home-bnnr/';
const prefix_mgmtHomePopup = 'mgmt/home-popup/';
const prefix_tos = 'tos/';
const prefix_tosHst = 'tos/hst/';

export const ApiConstant = {
	mgmtFaq: {
		list: `${api_prefix}${prefix_mgmtFaq}list`,
		detail: `${api_prefix}${prefix_mgmtFaq}`
	},
	mgmtAnncmt: {
		list: `${api_prefix}${prefix_mgmtAnncmt}list`,
		detail: `${api_prefix}${prefix_mgmtAnncmt}detail`
	},
	mgmtApplyAsk: {
		save: `${api_prefix}${prefix_mgmtApplyAsk}save`
	},
	mgmtExpertAsk: {
		save: `${api_prefix}${prefix_mgmtExpertAsk}save`,
		list: `${api_prefix}${prefix_mgmtExpertAsk}list`
	},
	mgmtEvent: {
		list: `${api_prefix}${prefix_mgmtEvent}list`,
		detail: `${api_prefix}${prefix_mgmtEvent}`
	},
	mgmtHomeBnnr: {
		list: `${api_prefix}${prefix_mgmtHomeBnnr}list`
	},
	mgmtHomePopup: {
		listHomepage: `${api_prefix}${prefix_mgmtHomePopup}list`
	},
	scrap: {
		serverRequest: ''
	},
	tosHst: {
		list: `${api_prefix}${prefix_tos}list/all`,
		detail: `${api_prefix}${prefix_tosHst}`
	}
};
